module.exports = {
    log_in: "Anmelden",
    language_select: "Sprache"
}